import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { enclosureTypes, glassTypes, coatingOptions, hardwareFinishes, handleStyles } from '../constants';

const ContactStep = ({ config, updateContact, honeypot, setHoneypot }) => (
  <div className="grid md:grid-cols-2 gap-8">
    <div>
      <h3 className="text-xl font-semibold mb-6">Your Information</h3>
      {/* Honeypot */}
      <div aria-hidden="true" style={{ position: 'absolute', left: '-9999px', top: '-9999px', opacity: 0, height: 0, overflow: 'hidden' }}>
        <label htmlFor="sd-website">Website</label>
        <input type="text" id="sd-website" name="website" value={honeypot} onChange={(e) => setHoneypot(e.target.value)} tabIndex={-1} autoComplete="off" />
      </div>
      <div className="space-y-4">
        <div>
          <Label htmlFor="name">Full Name *</Label>
          <Input id="name" data-testid="contact-name" placeholder="John Doe" value={config.contact.name} onChange={(e) => updateContact('name', e.target.value)} />
        </div>
        <div>
          <Label htmlFor="email">Email Address *</Label>
          <Input id="email" data-testid="contact-email" type="email" placeholder="john@example.com" value={config.contact.email} onChange={(e) => updateContact('email', e.target.value)} />
        </div>
        <div>
          <Label htmlFor="phone">Phone Number *</Label>
          <Input id="phone" data-testid="contact-phone" type="tel" placeholder="(830) 555-1234" value={config.contact.phone} onChange={(e) => updateContact('phone', e.target.value)} />
        </div>
        <div>
          <Label htmlFor="address">Project Address (optional)</Label>
          <Input id="address" data-testid="contact-address" placeholder="123 Main St, Canyon Lake, TX" value={config.contact.address} onChange={(e) => updateContact('address', e.target.value)} />
        </div>
        <div>
          <Label htmlFor="timeline">Project Timeline</Label>
          <select id="timeline" data-testid="contact-timeline" className="w-full h-10 px-3 rounded-md border border-input bg-background" value={config.contact.timeline} onChange={(e) => updateContact('timeline', e.target.value)}>
            <option value="">Select timeline...</option>
            <option value="asap">As soon as possible</option>
            <option value="1-2-weeks">1-2 weeks</option>
            <option value="1-month">Within a month</option>
            <option value="2-3-months">2-3 months</option>
            <option value="planning">Just planning</option>
          </select>
        </div>
      </div>
    </div>

    <div>
      <h3 className="text-xl font-semibold mb-6">Design Summary</h3>
      <Card className="bg-gray-50">
        <CardContent className="p-4 space-y-3 text-sm">
          <div className="flex justify-between">
            <span className="text-muted-foreground">Enclosure:</span>
            <span className="font-medium">{enclosureTypes.find(e => e.id === config.enclosureType)?.name}</span>
          </div>
          {config.enclosureType !== 'sliding' && config.enclosureType !== 'neo-angle' && (
            <div className="flex justify-between">
              <span className="text-muted-foreground">Hinge:</span>
              <span className="font-medium">{config.hingePosition === 'left' ? 'Left' : 'Right'}</span>
            </div>
          )}
          {config.enclosureType === 'door-panel' && (
            <div className="flex justify-between">
              <span className="text-muted-foreground">Door Position:</span>
              <span className="font-medium">{config.doorPosition === 'left' ? 'Left' : 'Right'}</span>
            </div>
          )}
          <div className="flex justify-between">
            <span className="text-muted-foreground">Dimensions:</span>
            <span className="font-medium">
              {config.isComplex ? 'Complex - To discuss' :
                config.enclosureType === 'neo-angle'
                  ? `${config.dimensions.side1}" × ${config.dimensions.front}" × ${config.dimensions.side2}"`
                  : `${config.dimensions.width}" × ${config.dimensions.height}"`}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="text-muted-foreground">Glass:</span>
            <span className="font-medium">{glassTypes.find(g => g.id === config.glassType)?.name}, {config.glassThickness}"</span>
          </div>
          <div className="flex justify-between">
            <span className="text-muted-foreground">Coating:</span>
            <span className="font-medium">{coatingOptions.find(c => c.id === config.coating)?.name}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-muted-foreground">Hardware:</span>
            <span className="font-medium">{hardwareFinishes.find(h => h.id === config.hardwareFinish)?.name}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-muted-foreground">Handle:</span>
            <span className="font-medium">{handleStyles.find(h => h.id === config.handleStyle)?.name}</span>
          </div>
        </CardContent>
      </Card>

      <div className="mt-4 p-4 bg-primary/5 rounded-lg">
        <p className="text-sm text-muted-foreground">
          By submitting, our team will review your design and contact you within 24 hours with a free quote and to schedule a consultation.
        </p>
      </div>
    </div>
  </div>
);

export default ContactStep;
